<template>
	<v-app id="change-password">
		<v-layout row align-center justify-center v-if="!showPasswordFields">
			<v-container style="max-width: 1200px">
				<h1 style="margin-bottom: 50px;">Potwierdź rejestrację</h1>
				<v-checkbox
					aria-label="rodo agreement checkbox"
					v-model="checkbox1.status"
					data-vv-name="rodoCheckbox"
					data-vv-as="zgody przetwarzania danych osobowych"
					:error-messages="vErrors.collect('rodoCheckbox')"
					v-validate="'required'"
					:true-value="true"
					:false-value="null"
				>
					<span slot="label" style="color: black;">
						Wyrażam zgodę na przetwarzanie przez Ministerstwo Spraw Zagranicznych danych zawartych w formularzu rejestracyjnym, dla potrzeb związanych z utworzeniem konta w aplikacji https://egranty.msz.gov.pl, zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (Dz. Urz. UE L 119 z 04.05.2016).
						<span style="color: red">*</span>
					</span>
				</v-checkbox>
				<v-checkbox
					aria-label="terms and conditions agreement checkbox"
					v-model="checkbox2.status"
					data-vv-name="statusCheckbox"
					data-vv-as="zgody Regulaminu"
					:error-messages="vErrors.collect('statusCheckbox')"
					v-validate="'required'"
					:true-value="true"
					:false-value="null">
					<span slot="label" style="color: black;">Akceptuję treść <a target="_blank"
						rel="noopener noreferrer"
						:href="`${publicPath}eGranty - regulamin_aplikacji.pdf`" download>Regulaminu</a> korzystania  z aplikacji konkursowej i oświadczam, że zapoznałam/em się z zawartą w nim informacją o przetwarzaniu moich danych osobowych <span
							style="color: red">*</span>
					</span>
				</v-checkbox>
				<v-btn color="primary" :disabled="!allCheckboxesSelected" @click="step=2" style="margin-top: 30px">
					Kontynuuj
				</v-btn>
			</v-container>
		</v-layout>
		<v-container fluid fill-height v-else>
			<v-layout align-center justify-center>
				<div class="text-xs-center" style="width: 380px;">
					<h1>Ustaw hasło</h1>
					<v-flex class="my-3">
						Hasło powinno zawierać co najmniej:
						10 znaków,
						jedną dużą literę,
						jedną małą literę,
						jedną cyfrę,
						jeden znak specjalny.
					</v-flex>
					<v-flex xs12>
						<v-text-field
							browser-autocomplete="off"
							name="Hasło"
							label="Hasło"
							aria-label="password"
							for="setup-password-view-password"
							id="setup-password-view-password"
							v-model="formData.password"
							data-vv-name="password"
							data-vv-as="Hasło"
							:type="showPassword? 'text' : 'password'"
							:append-icon="showPassword? 'visibility' : 'visibility_off'"
							@click:append="showPassword = !showPassword"
							:error-messages="vErrors.collect('password')"
							@click="disableErrorMessage"
							v-validate="'required'"
						></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							browser-autocomplete="off"
							name="Potwierdź"
							label="Potwierdź hasło"
							aria-label="password confirmation"
							for="setup-password-view-password-confirmation"
							id="setup-password-view-password-confirmation"
							v-model="formData.passwordConfirmation"
							data-vv-name="passwordConfirmation"
							data-vv-as="Potwierdź"
							:type="showConfirm? 'text' : 'password'"
							:append-icon="showConfirm? 'visibility' : 'visibility_off'"
							@click:append="showConfirm = !showConfirm"
							:error-messages="vErrors.collect('passwordConfirmation')"
							@click="disableErrorMessage"
							v-validate="'required'"
						></v-text-field>
					</v-flex>
					<v-expand-transition>
						<div v-show="showErrorMessage" style="color: red">
							{{errorMessage}}
						</div>
					</v-expand-transition>
					<div>
						<v-btn color="primary" @click="setUpPassword">Ustaw</v-btn>
					</div>
				</div>
			</v-layout>
		</v-container>
	</v-app>
</template>

<script>
	import {Api} from "@/api";
	import {Credentials} from "@/api/generated/Credentials";
	import dataValidation from "../utils/dataValidation";

	export default {
		name: "SetupPasswordView",

		data() {
			return {
				publicPath: process.env.BASE_URL,
				formData: {
					password: "",
					token: "",
					passwordConfirmation: "",
				},
				errorMessage: '',
				showErrorMessage: false,

				showPassword: false,
				showConfirm: false,
				step: 1,
				checkbox1: {
					status: null,
				},
				checkbox2: {
					status: null,
				},
			};
		},

		methods: {
			disableErrorMessage() {
				this.showErrorMessage = false;
			},

			setUpPassword() {
				this.$validator.validateAll().then((result) => {
					if (!result) return;
					let validationResult = dataValidation.validPassword(this.formData.password, this.formData.passwordConfirmation);
					if (validationResult === "OK") {
						if (this.$route.query.bidderEmailToken === undefined) {
							Credentials.postSetupPassword(this, this.formData, () => {
									this.$router.push("/setup-password-confirmed");
								},
								errorResponse => {
									this.errorMessage = errorResponse.errors[0];
									this.showErrorMessage = true;
								});
						} else if (this.$route.query.token === undefined) {
							Credentials.putSetupNewBidderEmail(this, {
									password: this.formData.password,
									token: this.formData.token
								}, () => {
									this.$router.push("/setup-email-confirmed");
								},
								errorResponse => {
									this.errorMessage = errorResponse.errors[0];
									this.showErrorMessage = true;
								});
						}
					} else {
						this.errorMessage = validationResult;
						this.showErrorMessage = true;
					}
				});
			}
		},

		beforeMount() {
      let path;

			if (this.$route.query.token === undefined) {
				this.formData.token = this.$route.query.bidderEmailToken;
        path = "/credentials/user-exists-by-email-token";
			} else if (this.$route.query.bidderEmailToken === undefined) {
				this.formData.token = this.$route.query.token;
        path = "/credentials/user-exist";
			} else {
        this.$router.push("/not-found");
      }

      Api.getWithParam(this, path, {token: this.formData.token}, response => {
        if (response.status !== "OK") {
          this.$router.push("/not-found");
        }
      }, () => {
        this.$router.push("/not-found");
      });
		},

		computed: {
			allCheckboxesSelected () {
				return this.checkbox1.status && this.checkbox2.status;
			},
			showPasswordFields () {
				return this.step === 2 || this.$route.query.token === undefined;
			}
		},

	};
</script>

<style scoped>
	label span,
	label span a {
		font-size: 16px;
	}
</style>
